import { Component } from '@angular/core';
import { HeaderComponent } from '@shared/components/header/header.component';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-dashboard-query',
  imports: [
    HeaderComponent,
    RouterOutlet,
  ],
  templateUrl: './dashboard-query.component.html',
  styleUrl: './dashboard-query.component.css'
})
export class DashboardQueryComponent {
}
